module.exports = __webpack_public_path__ + "static/media/8.f9e9d59f.png";